const OBSERVER_OPTIONS = {
  rootMargin: '-20% 0px',
};

const startAnimation = (slide) => {
  if (slide) {
    slide.classList.add('fade-in');
  }
};

const handlerIntersection = (entries, observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      startAnimation(entry.target);
      observer.unobserve(entry.target);
    }
  });
};

const initFadeInAnimation = () => {
  const slides = document.querySelectorAll('.start-fade-in');
  if (slides.length <= 0) {
    return;
  }

  const animationObserver = new IntersectionObserver(
      handlerIntersection,
      OBSERVER_OPTIONS
  );
  slides.forEach((slide) => {
    animationObserver.observe(slide);
  });
};

export {initFadeInAnimation};
